import has from 'lodash/has.js';
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment';

export default function Item({ dates = [] } = {}) {
    return {
        namespaced: true,

        state() {
            return {
                id: null,
                order: null,
            };
        },

        getters: {
            /**
             * @param state
             */
            hasChanges(state) {
                return data => {
                    return Object.keys(data).some(key => state[key] !== data[key]);
                };
            },

            /**
             * @param state
             * @param getters
             * @returns {function(*): *}
             */
            get(state, getters) {
                return field => {
                    if (typeof getters[field] === 'function') return getters[field]();

                    if (dates.includes(field)) return state[field] ? moment(state[field]) : null;
                    return state[field];
                };
            },
        },

        actions: {
            /**
             * @param context
             * @param data
             * @returns {Promise<any>}
             */
            hydrate(context, data) {
                return new Promise(resolve => {
                    context.commit('HYDRATE', data);

                    resolve();
                });
            },
        },

        mutations: {
            /**
             * @param state
             * @param data
             * @constructor
             */
            HYDRATE(state, data) {
                Object.keys(state).forEach(key => {
                    if (has(data, key)) state[key] = data[key];
                });
            },
        },
    };
}
